<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div>
        <div class="padding-5 avatar">
          <img class="width-100 height-100" src="../assets/images/logo.png" alt="">
        </div>
        <span>高人效智能客服系统</span>
      </div>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside ref="aside" :width="isCollapse ? '64px' : '200px'">
          <div class="toggle-button" @click="toggleCollapse">|||</div>
          <div class="menu-scroll-y" :style="{
            height: menuHeight + 'px'
          }">
            <!-- 侧边栏菜单区域 -->
            <el-menu unique-opened :collapse="isCollapse" :collapse-transition="false" router :default-active="$route.path" background-color="#333744" text-color="#fff" active-text-color="#409FFF">
              <el-menu-item index="/board">
                <i class="iconfont icon-shouye"></i>
                <span slot="title">首页</span>
              </el-menu-item>
              <!-- 一级菜单  -->
              <el-submenu :index="item.Id+''" v-for="item in menuList" :key="item.Id" >
                <!-- 一级菜单的模板区域 -->
                <template slot="title">
                  <i class="iconfont" :class="iconsObj[item.Component]"></i>
                  <span>{{ item.Title}}</span>
                </template>
                <!-- 二级菜单 -->
                <el-menu-item :index="'/' + subItem.Component" v-for="subItem in item.children" :key="subItem.Id">
                  <!-- 导航开启路由模式：
                    将index值作为导航路由 -->
                  <!-- 二级菜单的模板区域 -->
                  <template slot="title">
                    <i class="iconfont" :class="iconsObj[subItem.Component]"></i>
                    <span>{{ subItem.Title}}</span>
                  </template>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
      </el-aside>
      <!-- 右侧内容主体 -->
      <div class="main-container">
        <el-main>
          <!-- 面包屑导航区域 -->
          <breadcrumb :menuList="menuList" />
          <!-- 路由占位符 -->
          <router-view></router-view>
        </el-main>
      </div>
    </el-container>
  </el-container>
</template>

<script>
  import { chat_get, chat_post, toForm } from '@/api'
  const icon = {
      'config': 'icon-shezhi',
      'power': 'icon-yonghuming1',
      'monitor': 'icon-xitongjiankong',
      'menuList': 'icon-caidan',
      'dept': 'icon-jiaoseguanli',
      'role': 'icon-jiaose',
      'post': 'icon-qiyeguanli_gangweiguanli',
      'user': 'icon-yonghu',
      'customer': 'icon-kefu',
      'customerSer': 'icon-u',
      'messageLog': 'icon-web-icon-',
      'online': 'icon-ic_user_zx',
      'job': 'icon-dingshirenwu',
      'server': 'icon-zu1773',
      'feedback': 'icon-fankuiliebiao',
      'translate': 'icon-map-direction-full',
      'webSet': 'icon-caidan',
      'evaluate': 'icon-pingjia',
      'assessment': 'icon-kaohe1',
      'allEvaluate': 'icon-pingjia1',
      'transfer': 'icon-zhuanhua',
      'customer/user-tag': 'el-icon-paperclip',
      'liveTransfer': 'el-icon-film',
      'system/updatePwd': 'icon-yonghu',
      'system/resetPwd': 'icon-yonghu',
      'customer/user-quick-reply': 'el-icon-document',
      'assessment/shareList': 'el-icon-tickets',
      'assessment/weChatInfoList': 'el-icon-tickets',
      'customer/qrcode-config': 'el-icon-picture-outline-round',
      'customer/mapping': 'el-icon-picture-outline-round'
    }
import breadcrumb from './components/breadcrumb'
export default {
  data() {
    return {
      // 左侧菜单数据
      menuList: [],
      iconsObj: icon,
      // 是否折叠
      isCollapse: false,
      menuHeight: 0
    }
  },
  components: {
    breadcrumb
  },
  created() {
    this.getmenuList()
  },
  mounted() {
    let aside = this.$refs.aside.$el
    this.menuHeight = aside.clientHeight - 24
  },
  methods: {
    logout() {
      this.$confirm('确定要退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.sessionStorage.clear()
        window.localStorage.clear()
        this.$router.push('/login')
      }).catch(() => {

      })
    },
    // 获取所有的菜单
    getmenuList() {
      chat_get('/admin/menuList', {} , res => {
        if(res.status == 200) {
          // token失效
          if (res.data.hasOwnProperty('data')) {
            window.sessionStorage.clear()
            window.localStorage.clear()
            this.$router.push('/login')
            return;
          }
          this.menuList = res.data.MessageContent
        }
      })
    },
    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}

.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}

.main-container {
  flex-grow: 1;
  position: relative;
}
.el-main {
  background-color: #eaedf1;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
}

.iconfont {
  margin-right: 10px;
}
.avatar {
  width: 60px;
  height: 60px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
.menu-scroll-y {
  overflow-y: scroll;
  &::-webkit-scrollbar-track-piece {
    background: #373D41;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #333744;
    border-radius: 0px;
  }
}
</style>
